import React from 'react';
import { Typography, Box, useTheme } from "@mui/material";

const Header = ({ title, subtitle }) => {
    return (
        <Box>
            <Typography
                variant="h2"
                fontWeight="bold"
            >
                {title}
            </Typography>
            <Typography variant="h5" >
                {subtitle}
            </Typography>
        </Box>
    );
};

export default Header;